module.exports = __webpack_public_path__ + "static/favicon-512-1f342bba84353a9a82af0e7f78fc3284.png";